// extracted by mini-css-extract-plugin
export var Link = "layout-module--Link--+2sxY";
export var LogoAndNaviContainer = "layout-module--LogoAndNaviContainer--HfZrJ";
export var Wrapper = "layout-module--Wrapper--gyiGK";